import { FormattedMessage } from 'react-intl';

import { Season26TutorialDialog } from '@sorare/core/src/components/dialog/Season26TutorialDialog';
import { Season26TutorialStep } from '@sorare/core/src/components/dialog/Season26TutorialStep';
import { glossary } from '@sorare/core/src/lib/glossary';

import { QuickPlayTutorialHeader } from 'components/quickPlay/QuickPlayTutorialHeader';

import { QuickPlayTutorialFooter } from '../QuickPlayTutorialFooter';
import type { QuickPlayTutorialDialogType } from '../types';
import { L10Average } from './L10Average';
import { Success } from './Success';
import { Targets } from './Targets';
import background from './assets/background.png';

type Props = {
  open: boolean;
  onContinue: () => void;
  loading: boolean;
  onSelect: (type: QuickPlayTutorialDialogType) => void;
};
export const TargetDialog = ({
  open,
  onContinue,
  loading,
  onSelect,
}: Props) => {
  return (
    <Season26TutorialDialog
      open={open}
      onClose={onContinue}
      color="#F58426"
      textColor="var(--c-black)"
      headerBackgroundUrl={background}
      disableAnimation
      hideTextureBackground
      gap={2}
      titleGroup={
        <QuickPlayTutorialHeader
          overline={<FormattedMessage {...glossary.howToPlay} />}
          title={
            <FormattedMessage
              id="TargetDialog.title"
              defaultMessage="Targets"
            />
          }
        />
      }
      items={[
        <Season26TutorialStep
          stepTitle={
            <FormattedMessage
              id="QuickplayTutorialDialog.steps.l10"
              defaultMessage="L10 Average"
            />
          }
          key="l10-average"
          fullHeight={false}
        >
          <L10Average />
        </Season26TutorialStep>,
        <Season26TutorialStep
          stepTitle={
            <FormattedMessage
              id="TargetDialog.title"
              defaultMessage="Targets"
            />
          }
          key="targets"
          fullHeight={false}
        >
          <Targets key="targets" />
        </Season26TutorialStep>,
        <Season26TutorialStep
          stepTitle={
            <FormattedMessage
              id="QuickplayTutorialDialog.steps.success"
              defaultMessage="Success"
            />
          }
          key="success"
          fullHeight={false}
        >
          <Success />
        </Season26TutorialStep>,
      ]}
      footer={
        <QuickPlayTutorialFooter
          onSelect={onSelect}
          onContinue={onContinue}
          loading={loading}
          selectedType="targets"
        />
      }
    />
  );
};
